import { useMessageTemplatesAutomationQuery, usePropertyEmailQuery, useSendAttachmentEmailForDocumentMutation, useSendReservationEmailMutation } from 'src/api/api.generated'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'
import { filterMessageTemplate } from 'src/app/pages/settings/mail-templates/mail-template-list/filter-message-template'

export default function SendCommunicationEmailCrud({ propertyId, tenantId }: { propertyId: string; tenantId: string }) {
  const showError = useErrorSnackBar()
  const { data: propertyEmailData, loading: propertyEmailLoading } = usePropertyEmailQuery({
    variables: {
      filter: {
        id: { eq: propertyId },
        tenantId: { eq: tenantId },
      },
    },
    onError: showError,
  })

  const { data: messageTemplatesData, loading: messageTemplateLoading } = useMessageTemplatesAutomationQuery({
    variables: {
      filter: {
        customOnly: false,
        isActive: true,
        tenantId: { eq: tenantId },
        code: { eq: 'COMMUNICATION' },
        type: 'MAIL',
      },
    },
    onError: showError,
  })

  const [sendCommunicationEmail, { loading: sendCommunicationEmailLoading }] = useSendReservationEmailMutation({
    onError: showError,
    refetchQueries: ['GetReservationEmails'],
  })

  const [sendAttachmentEmailForDocument, { loading: sendAttachmentEmailForDocumentLoading }] = useSendAttachmentEmailForDocumentMutation({
    onError: showError,
  })

  const propertyEmail = propertyEmailData?.properties?.[0]?.mailContacts?.find((mail) => mail.type === 'GUEST')?.value ?? propertyEmailData?.properties?.[0]?.mailContacts?.[0]?.value
  const messageTemplateId =
    (messageTemplatesData?.messageTemplates ?? [])?.filter((messageTemplate) => {
      return filterMessageTemplate(messageTemplate, messageTemplatesData?.messageTemplates ?? [])
    })?.[0]?.id ?? null

  return {
    propertyEmail: propertyEmail ?? '',
    messageTemplateId,
    loading: propertyEmailLoading || sendCommunicationEmailLoading || messageTemplateLoading || sendAttachmentEmailForDocumentLoading,
    sendCommunicationEmail,
    sendAttachmentEmailForDocument,
  }
}
